<div class="www-ord-det-mod">
  <div class="www-ord-det-mod__close">
    <a (click)="closeModal()">x zamknij okno </a>
  </div>
  <div class="www-ord-det-mod__col">
    <h3 class="www-ord-det-mod__sub-tit">TWOJE ZAMÓWIENIE</h3>

    <div class="www-ord-det-mod__ord">
      <!-- <img
        class="www-ord-det-mod__ord__img"
        [src]="order()?.photo ? order()?.photo : 'assets/images/pages/my-data.temp.webp'"
      /> -->
      <img class="www-ord-det-mod__ord__img" [src]="order().list_photo" />
      <div class="www-ord-det-mod__ord__text">
        <label>SZKOLENIE</label>
        <p>
          {{ order().training_name }}
        </p>
        <label>DATA</label>
        <p>
          {{ order().start_date | date: 'dd/MM/yyyy' }}&nbsp;|&nbsp;{{ order().start_date | date: 'HH:mm' }}
          <!-- {{ ' - ' + order().end_date | date: 'HH:mm' }} -->
        </p>

        <label>MIEJSCE</label>
        <!-- <p>{{ order().placorder().city }}, {{ order().placorder().address }}, {{ order().placorder().name }}</p> -->
        <p>{{ order().place_name }}</p>
        <label>ILOŚĆ BILETÓW</label>
        <div class="www-ord-det-mod__ord__text__tickets">
          <p>{{ order().tickets }}</p>
        </div>

        <label>CENA</label>
        <p>{{ order().total_price > 0 ? order().total_price + ' PLN' : 'Szkolenie bezpłatne' }}</p>
      </div>
    </div>

    <div class="www-ord-det-mod__sum">
      <div>
        <label>SUMA ŁĄCZNA</label>
        <p>{{ order().total_price ? (order().total_price! | mask: 'separator.2') + ' PLN' : '0 PLN' }}</p>
      </div>
      <div>
        @if (user()) {
          <label>RABAT {{ user()!.type === UserType.ELITE ? 'ELITE' : 'MEMBER' }}</label>
          <p>
            {{ user()!.type === UserType.ELITE ? '20%' : '10%' }}
          </p>
        }
      </div>
    </div>
  </div>
</div>
